import { Tables } from '../../../../../../modules/API/Tables/Tables'
import { ITableDataProvider } from '../../../../../../generic/universal-table/types/data-provider.types'
import { carTableAdapter } from '../adapters/carTable.adapter'
import { CarCreatePayload, CarUiRow, CarUpdatePayload } from '../types/carTable.types'

export const carTableService: ITableDataProvider<
  CarUiRow,
  CarCreatePayload,
  CarUpdatePayload
> = {
  getList: async (): Promise<CarUiRow[]> => {
    const rows = await Tables.getCarList()
    return rows.map(carTableAdapter.fromApi)
  },

  create: async (payload: CarCreatePayload): Promise<CarUiRow> => {
    const created = await Tables.createCar(payload)
    return carTableAdapter.fromApi(created)
  },

  update: async (
    id: number | string,
    payload: CarUpdatePayload
  ): Promise<CarUiRow> => {
    const updated = await Tables.updateCar(Number(id), payload)
    return carTableAdapter.fromApi(updated)
  },

  remove: async (id: number | string): Promise<void> => {
    await Tables.deleteCar(Number(id))
  },
}
